import type { DemoKey } from './keys';

export const ur: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': 'جیومیٹری · 3D',
  'panel.figure': 'شکل',
  'panel.dims': 'ابعاد',
  'panel.style': 'ظاہری شکل',
  'panel.lines': 'خاص لکیریں',
  'style.body': 'جسم',
  'style.line': 'لکیر',
  'style.cut': 'حصہ',
  'style.labels': 'کونوں کے لیبل',
  'group.face': 'سطح کے قطر / مولد',
  'group.space': 'قطر / محور / اوسط',
  'split.label': 'حصہ',
  'btn.animate': 'حرکت',
  'btn.reset': 'دوبارہ ترتیب',
  'hint.line1': 'گھمانے کے لیے گھسیٹیں · زوم کے لیے اسکرول',
  'hint.line2': 'منتخب کرنے کے لیے لکیر پر کلک کریں',
  'fig.cuboid': 'مکعب مستطیل',
  'fig.cube': 'مکعب',
  'fig.triPrism': 'مثلثی منشور',
  'fig.hexPrism': 'مسدسی منشور',
  'fig.tetrahedron': 'چار سطحی',
  'fig.squarePyramid': 'مربع اہرام',
  'fig.cylinder': 'استوانہ',
  'fig.cone': 'مخروط',
  'fig.sphere': 'کرہ',
  'fig.frustumPyramid': 'اہرامی قطعہ',
  'fig.frustumCone': 'مخروطی قطعہ',
  'dim.length': 'لمبائی',
  'dim.width': 'چوڑائی',
  'dim.height': 'اونچائی',
  'dim.side': 'پہلو',
  'dim.radius': 'رداس',
  'dim.r1': 'نچلا رداس',
  'dim.r2': 'اوپری رداس',
  'dim.sideBase': 'بنیاد کا پہلو',
  'dim.sideTop': 'اوپری پہلو',
  'info.face': 'سطح',
  'info.center': 'مرکز سے',
  'info.diagonal': 'قطر',
  'info.axial': 'محوری قطر',
  'info.diameter': 'قطر',
  'info.generator': 'مولد',
  'info.axis': 'محور',
  'info.height': 'اونچائی',
  'info.median': 'وسطی خط',
  'info.apothem': 'اپوتھیم',
  'info.diameterBase': 'بنیاد کا قطر',
  'info.diameterTop': 'اوپری قطر',
};
